import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSectionBoot';
import DivLayout from 'components/sales/divLayout/divLayout';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import ModalPop from 'components/sales/modal/modal';
import {Link} from 'react-router-dom';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import moment from 'moment';

const ChangeAssingee = ({
                            engineerList,
                            pmSoftwareUpdateAssignee,
                            pmAssigneeList,
                            match,
                        }) => {
    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [maintenanceDate, setMaintenanceDate] = useState('');
    const [assigneeId, setassigneeId] = useState('');
    const [assigneeName, setassigneeName] = useState('');
    const [isModal, setIsModal] = useState(false);
    const headerBtns = () => {
        return (
            <Fragment>
                <Link to="#" onClick={() => onAssign()} className="btn btn-primary">
                    <img src={Images?.ArrowRight} alt=""></img>
                    {localization.assign}
                </Link>
            </Fragment>
        );
    };

    useEffect(() => {
        (async () => {
            const date =
                (await JSON.parse(localStorage.getItem('viewDetail'))) &&
                JSON.parse(localStorage.getItem('viewDetail'))[0].maintaince_date;
            handleDateChange(date);

            const assignee_id =
                (await JSON.parse(localStorage.getItem('viewDetail'))) &&
                JSON.parse(localStorage.getItem('viewDetail'))[0].assigned_to_id;

            const assigneeName =
                (await JSON.parse(localStorage.getItem('viewDetail'))) &&
                JSON.parse(localStorage.getItem('viewDetail'))[0].assigned_to;
            setMaintenanceDate(date);
            setassigneeId(assignee_id);
            setassigneeName(assigneeName);
        })();
    }, []);

    const onAssign = async () => {
        if (maintenanceDate !== '' && assigneeId !== '') {
            setIsLoading(true);
            const res = await pmSoftwareUpdateAssignee(
                {
                    pm_site_id: match.params.manageId,
                    maintenance_date: maintenanceDate,
                    assignee_id: assigneeId
                }
            );

            setIsLoading(false);
            if (res === true) {
                setIsModal(true);
            } else setIsModal(false);
        }
    };

    const handleDateChange = (val) => {
        setMaintenanceDate(val);
    };

    const handleModalHide = () => setIsModal(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await engineerList(match.params.id);
            setIsLoading(false);
        })();
    }, []);

    return (
        <Layout
            title={localization.managePm}
            Buttons={headerBtns}
            isLoading={isLoading}
            isGoback
            linkUrl={`${baseUrl}/pm-sities`}
        >
            <CardSection title={localization.schedulePm}>
                <div className="row">
                    <div className="col-12">
                        <div className="details-listing">
                            <DivLayout
                                heading={localization.currentMaintenanceDate}
                                data={maintenanceDate}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-6 col-sm-12">
                        <DatePicker
                            handleChange={handleDateChange}
                            value={moment(maintenanceDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                            label={localization.scheduleMaintenanceDate}
                            displayFormat="DD-MM-YYYY"
                            returnFormat="DD-MM-YYYY"
                            minimumDate={new Date()}
                        />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <DropDownInput
                            label={localization.selectAssignee}
                            data={pmAssigneeList}
                            required
                            isStarRequired={true}
                            getIdValue={(val) => setassigneeId(val.id)}
                            value={assigneeName}
                        />
                    </div>
                </div>


            </CardSection>

            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt=""/>
                    </div>
                    <h5>{localization.assignedSuccessfully}</h5>
                    <Link to={`${baseUrl}/pm-software-sites`} className="btn btn-primary mb-4">
                        {localization.viewPmList} <img src={Images?.ArrowRight} alt=""/>
                    </Link>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default ChangeAssingee;
